import { render, staticRenderFns } from "./TableRiskAppraisal.vue?vue&type=template&id=7b6b5e9f&scoped=true"
import script from "./TableRiskAppraisal.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal.vue?vue&type=style&index=0&id=7b6b5e9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6b5e9f",
  null
  
)

export default component.exports